import { render, staticRenderFns } from "./MeetingStatusChips.vue?vue&type=template&id=671d814c"
import script from "./MeetingStatusChips.vue?vue&type=script&lang=js"
export * from "./MeetingStatusChips.vue?vue&type=script&lang=js"
import style0 from "./MeetingStatusChips.vue?vue&type=style&index=0&id=671d814c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports